import { createSelector, createSelectorFactory, defaultMemoize } from '@ngrx/store';

import { UserSelectors } from '@recruitee/account-data';
import type { ShortInterviewResultRequest } from '@recruitee/interview-result-request-types';
import { createEntityCollectionStore, memoizeSelector } from '@recruitee/ngrx';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<ShortInterviewResultRequest>()(
    'BriefInterviewScheduleResultRequestsCollection',
    {
      references: makeRef => [
        makeRef('adminId', 'admin', id => createSelector(UserSelectors.byId(id!), state => state!)),
      ],
      customActions: adapter => ({
        references: (state, payload: ShortInterviewResultRequest[]) =>
          adapter.updateOrCreateMany(state, payload),
      }),
    },
  );

const BriefInterviewScheduleResultRequestsCollectionSelectors = {
  ...selectors,
  byIds: memoizeSelector((interviewScheduleResultRequestsIds: number[]) =>
    createSelectorFactory(defaultMemoize)(
      ...interviewScheduleResultRequestsIds.map(interviewScheduleResultRequestsIds =>
        selectors.byIdWithReferences(interviewScheduleResultRequestsIds),
      ),
      (...result: ShortInterviewResultRequest[]) => result,
    ),
  ),
};

export {
  actions as BriefInterviewScheduleResultRequestsCollectionActions,
  BriefInterviewScheduleResultRequestsCollectionSelectors,
  reducer as BriefInterviewScheduleResultRequestsCollectionReducer,
  namespace as BriefInterviewScheduleResultRequestsCollectionNamespace,
};
